<div class="container-fluid " style="padding-left: 0;">
  <div class="navbar-header" style="width: 60%;">
    <div class="brand_logo">
      <div class="left-logo">
        <img class="logo_style" [src]="logoPath">
      </div>
      <div class="js-doc">
        <div class="top-bar-item">
          <a (click)="onSideMenuClick($event)" [title]="'label_toggle_menu' | translate" class="hamburger-menu">
            <i class="fa fa-bars"></i>
          </a>
        </div>
        <div class="top-bar-item ausHeader" *ngIf="eventListOptions.length">
          <p-dropdown [options]="eventListOptions" class="transperentDropdown" [(ngModel)]="selectedEvent"
           (onChange)="changeFilter($event)">
            <ng-template let-item pTemplate="selectedItem">
              <span><img [src]="getImageSrc(item.imageId)" (error)="onImageError($event)"
                  style="width:25px;vertical-align:middle" /></span>
              <span
               style="vertical-align:middle; margin-left: .5em;font-size: 14px;font-weight: bold;">{{item?.label}}</span>
            </ng-template>
            <ng-template let-event pTemplate="eventListOptions">
              <div class="country-item" style="display:-webkit-inline-flex;">
                <img [src]="getImageSrc(event.imageId)" (error)="onImageError($event)"
                  style="max-width: 50px; vertical-align:middle"/>
                <div style="padding: 8px;font-size: 16px;font-weight: 500;">{{ event.label.length > 30 ? (event.label |
                  slice:0:30) + '...' : event.label }}</div>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
        </div>
    </div>
  </div>

  <div class="nav-right-menu collapse navbar-collapse">
    <div class="nav navbar-nav navbar-right">
      <div class="top-bar-item notifications-bell" [title]="'label_notifications' | translate"
        (click)="getNotificationListAndToggle($event)">
        <a [ngClass]="unReadNotificatonsCount?'nav-notifications-icon-with-dot':'nav-notifications-icon'">
        </a>
      </div>

      <div class="profile-menu-button top-bar-item">
        <p-menu #menu [popup]="true" [model]="items"></p-menu>
        <a (click)="menu.toggle($event)">
          <img class="user-photo" src="{{profileUrl}}" onerror="src='/assets/images/temp/default_profile.png'">
          {{userFullName}}
          <i class="fa fa-angle-down" aria-hidden="true"></i>
        </a>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="hasShowNotificationBar" class="notification-sidebar" position="right">
  <div class="notification-container">
    <div class="header">{{notificationLabel}}</div>
    <div class="content">
      <app-notification-mg1 [notifications]="notifications" (loadMoreNotification)="loadMoreNotification()">
      </app-notification-mg1>
    </div>
  </div>
</p-sidebar>

<p-dialog modal="true" styleClass="add-terms-popup" [(visible)]="changePasswordPopup" [closable]="false"
  [contentStyle]="{'width':'600px'}" class="profilePopup">
  <p-header translate>
    label_change_password
  </p-header>
  <app-change-password [(changePasswordPopup)]="changePasswordPopup"
    (isShowChangePassword)="onCancelChangePassword($event)"></app-change-password>
</p-dialog>

<p-dialog class="profilePopup" modal="false" styleClass="edit-profile-popup" position="center center"
  [(visible)]="editProfilePopup" [contentStyle]="{'overflow':'visible'}">
  <p-header>
    Edit Profile
  </p-header>
  <app-edit-profile [(editProfilePopup)]="editProfilePopup" (showProfilePopup)="onCancelEditProfile($event)">
  </app-edit-profile>
</p-dialog>